/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Calendar, Cell, Grid, VFlow } from 'bold-ui'
import { Agenda, AgendaEvent, Weekday } from 'components/agenda'
import { AgendaEventProps } from 'components/agenda/AgendaEventWrapper'
import { useState } from 'react'

import { AgendamentoCadastroView } from './cadastro-agendamento/AgendamentoCadastroView'
import { FechamentoAgenda } from './components/FechamentoAgenda'
import { EventoAgendaProfissional } from './model'

const dummyEvents = (init: Date, end: Date): EventoAgendaProfissional[] => [
  { tipo: 'fechamento', start: init, end: end, title: 'Agenda fechada [motivo do fechamento]' },
]

const dummyAvailableTimes = {
  [Weekday.MONDAY]: [
    { start: { hours: 13, minutes: 30 }, end: { hours: 18, minutes: 30 } },
    { start: { hours: 8, minutes: 30 }, end: { hours: 12, minutes: 0 } },
  ],
  [Weekday.TUESDAY]: [
    { start: { hours: 13, minutes: 30 }, end: { hours: 18, minutes: 30 } },
    { start: { hours: 8, minutes: 30 }, end: { hours: 12, minutes: 0 } },
  ],
  [Weekday.WEDNESDAY]: [
    { start: { hours: 13, minutes: 30 }, end: { hours: 18, minutes: 30 } },
    { start: { hours: 8, minutes: 30 }, end: { hours: 12, minutes: 0 } },
  ],
  [Weekday.THRUSDAY]: [
    { start: { hours: 13, minutes: 30 }, end: { hours: 18, minutes: 30 } },
    { start: { hours: 8, minutes: 30 }, end: { hours: 12, minutes: 0 } },
  ],
  [Weekday.FRIDAY]: [
    { start: { hours: 13, minutes: 30 }, end: { hours: 18, minutes: 30 } },
    { start: { hours: 8, minutes: 30 }, end: { hours: 12, minutes: 0 } },
  ],
}

export function AgendaView() {
  const [eventos, setEventos] = useState<EventoAgendaProfissional[]>([])
  const [currDate, setCurrDate] = useState<Date>(new Date())

  const handleNavigate = (init: Date, end: Date) => {
    //Navegação no calendário
    setCurrDate(init)
    setEventos(dummyEvents(init, end))
  }

  const handleSelectSlot = (start: Date, end: Date) => {
    //Click ou drag em slots
  }

  return (
    <Grid>
      <VFlow>
        <Cell>
          <Calendar visibleDate={currDate} onVisibleDateChange={setCurrDate} />
        </Cell>
        <Cell>
          <AgendamentoCadastroView />
        </Cell>
      </VFlow>
      <Cell flexGrow={1}>
        <Agenda<EventoAgendaProfissional>
          date={currDate}
          events={eventos}
          availableTimes={dummyAvailableTimes}
          minutesStep={30}
          onSelectSlot={handleSelectSlot}
          onNavigate={handleNavigate}
          eventComponent={EventComponent}
        />
      </Cell>
    </Grid>
  )
}

const EventComponent = (props: AgendaEventProps<EventoAgendaProfissional>) => {
  switch (props.event.tipo) {
    case 'fechamento':
      return <FechamentoAgenda {...props} />
    default:
      return <AgendaEvent {...props} />
  }
}
